function getAPIBaseUrl() {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (process.env.NODE_ENV === 'development') {
    const host = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
    return `http://${host}:3001`;
  }
  return '';
}

const API_BASE_URL = getAPIBaseUrl();

function getAccessCode() {
  return localStorage.getItem('niva_access_code') || '';
}

function getJwt() {
  return localStorage.getItem('niva_jwt') || '';
}

export function getAPIHeaders() {
  const headers = {
    'Content-Type': 'application/json',
    'x-access-code': getAccessCode(),
  };
  try {
    const nurseName = localStorage.getItem('niva_nurse_name');
    if (nurseName) headers['x-nurse-name'] = nurseName;
  } catch {
    // ignore
  }
  const jwt = getJwt();
  if (jwt) headers.Authorization = `Bearer ${jwt}`;
  return headers;
}

function apiErrorMessage(data) {
  if (typeof data.detail === 'string') return data.detail;
  if (Array.isArray(data.detail)) {
    return data.detail.map((item) => item.msg || item.message || JSON.stringify(item)).join('; ');
  }
  return (
    data.message
    || data.error?.message
    || (typeof data.error === 'string' ? data.error : null)
    || 'API request failed'
  );
}

export async function apiPost(path, body) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: 'POST',
    headers: getAPIHeaders(),
    body: JSON.stringify(body),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw Object.assign(new Error(apiErrorMessage(data)), {
      status: response.status,
      error: data,
    });
  }

  return data;
}

export async function apiGet(path) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: 'GET',
    headers: getAPIHeaders(),
  });

  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    throw Object.assign(new Error('API unavailable'), {
      status: 0,
      error: { message: 'Server did not return JSON. Is the API running?' },
    });
  }

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw Object.assign(new Error(apiErrorMessage(data)), {
      status: response.status,
      error: data,
    });
  }

  return data;
}

export async function apiPatch(path, body) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: 'PATCH',
    headers: getAPIHeaders(),
    body: JSON.stringify(body),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw Object.assign(new Error(apiErrorMessage(data)), {
      status: response.status,
      error: data,
    });
  }

  return data;
}

/** Verify stored access code with the server — rejects invalid codes and bogus 200 responses. */
export async function apiVerifyAccessCode() {
  const data = await apiGet('/api/verify');
  if (data?.valid !== true) {
    throw Object.assign(new Error('Invalid access code'), { status: 401 });
  }
  return data;
}
